export const CERTIFICATION_SCREEN_STATES = {
  REQUIRES_SCALE_PLAN: 'requires_scale_plan',
  REQUIRES_HISTORICAL_ANALYSIS: 'requires_historical_analysis',
  ANALYSIS_PENDING: 'analysis_pending',
  READY: 'ready'
};

const CERTIFICATION_SCREEN_COPY = {
  [CERTIFICATION_SCREEN_STATES.REQUIRES_SCALE_PLAN]: {
    title: 'Certifications',
    body: 'Your current plan does not include GitMe Certifications. Upgrade to the Scale plan to unlock certification badges and proof links.',
    ctaLabel: 'Go to Plan Configuration',
    ctaPath: '/settings/plan-configuration'
  },
  [CERTIFICATION_SCREEN_STATES.REQUIRES_HISTORICAL_ANALYSIS]: {
    title: 'Certifications',
    body: 'We need at least 12 full months of analysis history to evaluate certification badges. Extend your analysis window from Historical Analysis to continue.',
    ctaLabel: 'Go to Historical Analysis',
    ctaPath: '/settings/historical-analysis'
  },
  [CERTIFICATION_SCREEN_STATES.ANALYSIS_PENDING]: {
    title: 'Certifications',
    body: 'Your workspace is eligible for certifications, but this analysis is not ready yet. Open a support request and our team will check it for you.',
    ctaLabel: 'Open Support Request',
    ctaPath: '/settings/support'
  }
};

export const isCertificationScreenBlocked = screenState =>
  Boolean(screenState && screenState !== CERTIFICATION_SCREEN_STATES.READY);

export const getCertificationScreenOverlayContent = (
  screenState,
  screenStateMeta = null
) => {
  const content = CERTIFICATION_SCREEN_COPY[screenState];

  if (!content) {
    return null;
  }

  return {
    title: content.title,
    body: content.body,
    ctaLabel: screenStateMeta?.cta_label || content.ctaLabel,
    ctaPath: screenStateMeta?.cta_path || content.ctaPath
  };
};
